import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import _ from 'lodash';
import axios from 'axios';
import {Link, withRouter} from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import overlayFactory from 'react-bootstrap-table2-overlay';

import urls from '../../../../utils/urls';
import Header from '../../../Header/index';
import helpers from '../../../../utils/helpers';
import {ajaxHandler} from '../../../../utils/errors';
import {tokenHeader} from '../../../../utils/headers';
import formatters from "../../../../utils/formatters";
import {Spinner} from '../../../../components/Loading/Spinner';
import EmptyRow from '../../../../components/EmptyState/emptyRows';

import FiltersDefaultInternal from '../Filters/FiltersDefaultInternal';
import ExportReport from "../Grid/ExportReport";


class HomeInternal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            canCreateTrips: helpers.canUserCreateInternalTrip(props.user),
            trip_type: helpers.trip_type.INTERNAL,
            xhr: false,
            axiosSource: false,
            products: false,
            destination_areas: false,
            terminals: false,
            states: false,
            grouped_states: false,
            product: '',
            terminal: '',
            destination_area: '',
            status: '',
            truck_id: '',
            truck_plate: '',
            trailer_plate: '',
            carrier: '',
            driver_name: '',
            lte: '',
            gte: '',
            date_type: 'estimated_load_date',
            trips: false,
            total_trips: 0,
            page: 1,
            finishedFirstFetch: false,
            sortBy: ''
        }

    }

    componentWillMount() {
        this._fetchFiltersOptions();
        this._fetchShipments();
    }

    _fetchShipments = () => {
        if (this.state.xhr) {
            this.state.axiosSource.cancel('abort');
        }
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        this.setState({xhr: true, axiosSource: source});
        const task_url = this._generateNewQuery();
        axios.get(task_url, {...tokenHeader(), cancelToken: source.token})
            .then((response) => {
                this.setState({
                    trips: response.data.results,
                    xhr: false,
                    axiosSource: null,
                    total_trips: response.data.count,
                    finishedFirstFetch: true
                });
            })
            .catch((error) => {
                if(error.message && error.message === 'abort'){
                    return false;
                }
                this.setState({trips: [], xhr: false});
                ajaxHandler(error)
            })
    };

    _handleInput = (prop, value) => {

        if(['truck_plate', 'trailer_plate'].indexOf(prop) > -1){
            value = value.replace(/-/g, '');
        }

        this.setState({
            [prop]: value,
            page: 1
        }, this._fetchShipments);
    };

    _handleDate = (prop, value) => {
        this.setState({[prop]: value, page: 1}, this._fetchShipments);
    };

    _handleSelectChange = (ev) => {
        let target = ev.target;
        let prop = target.getAttribute('data-state-var');
        this.setState({
            [prop]: target.value,
            page: 1
        }, () => {
            if(prop === 'date_type'){
                if(!this.state.lte || !this.state.gte) return false;
            }
            this._fetchShipments();
        });
    };

    _generateNewQuery = () => {
        const getParams = this._generateParams();
        return `${urls.API_ROOT}/api/v1/trip/${getParams}`;
    };

    _generateParams = () => {
        let params = `?`;
        let filters = ['product', 'destination_area', 'terminal', 'status',
            'carrier', 'truck_id', 'driver_name', 'gte', 'lte', 'trip_type',
            'trailer_plate', 'truck_plate'
        ];
        filters.forEach(filter => {
            let value = this.state[filter];
            if (['gte', 'lte'].indexOf(filter) > -1) {
                filter = `${this.state.date_type}_${filter}`;
            }
            if (['truck_plate', 'trailer_plate'].indexOf(filter) > -1) {
                value = value.replace(/_/g, '');
                if(value.substr(-1) === '-'){
                    value = value.slice(0, -1);
                }
            }
            if (filter === 'status'){
                filter = 'status_list';
            }
            if (value && value !== '') {
                params = `${params}${filter}=${value}&`;
            }
        });

        if(this.state.page > 1){
            params = `${params}page=${this.state.page}&`;
        }

        if(this.state.sortBy !== ''){
            params = `${params}sort_by=${this.state.sortBy}&`;
        }

        return params
    };

    _fetchFiltersOptions = () => {
        const area = `${urls.API_ROOT}/api/v1/destinationarea/`;
        const terminal = `${urls.API_ROOT}/api/v1/terminal/`;
        const product = `${urls.API_ROOT}/api/v1/product/`;
        const state = `${urls.API_ROOT}/api/v1/state/`;
        axios.all([
            axios.get(area, tokenHeader()),
            axios.get(terminal, tokenHeader()),
            axios.get(product, tokenHeader()),
            axios.get(state, tokenHeader()),
        ])
            .then(axios.spread(function (areas, terminal, prod, state) {
                return {
                    areas,
                    terminals: terminal,
                    products: prod,
                    states: state
                }
            }))
            .then((data) => {
                let grouped_states = [];
                let states = [];
                let states_data = data.states.data.general_trips;
                Object.keys(states_data).forEach(key => {
                    states.push({
                        id: key, value: states_data[key]
                    });
                });
                states = states.sort(formatters.sortStates);

                states_data = data.states.data.grouped_states.general_trips;
                states_data.map(each => {
                    let key = each.groups.join(',');
                    grouped_states.push({
                        id: key, value: each.name
                    });
                });

                this.setState({
                    destination_areas: data.areas.data,
                    terminals: data.terminals.data,
                    products: data.products.data.filter(p => p.trip_type === helpers.trip_type.INTERNAL),
                    states, grouped_states
                })
            })
            .catch((error) => ajaxHandler(error))
    };

    _onTableChange = (type, { page, sizePerPage, filters, sortField, sortOrder }) => {
        if(type === 'pagination'){
            this.setState({page}, this._fetchShipments);
        }else if(type === 'sort'){
            this.setState({
                page: 1,
                sortBy: `${sortOrder === 'asc' ? '' : '-'}${sortField}`
            }, this._fetchShipments);
        }
    };

    rowEvents = {
        onClick: (e, row, rowIndex) => {
            this.props.history.push(`/trips/${row.id}`);
        }
    };

    render() {
        const columns = helpers.getUserHomeColumns(this.props.user, this.state.trip_type);

        let data = [];
        if (this.state.trips && this.state.trips instanceof Array) {
            this.state.trips.forEach(trip => {
                let row = {id: trip.id};
                columns.forEach(col => {
                    row[col.dataField] = _.get(trip, col.path, '-');
                });
                data.push(row);
            });
        }

        let filtersAvailable = this.state.destination_areas && this.state.products && this.state.terminals && this.state.states;
        if(!filtersAvailable){
            return (
                <div className={'main-dashboard'}>
                    <Header active={this.state.trip_type}/>
                    <div style={{height: '90vh'}} className={"valign-wrapper"}><Spinner/></div>
                </div>
            )
        }

        // Pagination
        const pagination = paginationFactory({
            page: this.state.page,
            sizePerPage: 10,
            totalSize: this.state.total_trips,
            hideSizePerPage: true
        });

        let excludedKeys = ['xhr', 'axiosSource', 'trips', 'total_trips', 'page'];
        let filterState = _.omit(this.state, excludedKeys);

        return (
            <div className={'main-dashboard'}>
                <Header active={this.state.trip_type}/>
                <div>
                    {this.state.canCreateTrips ?
                        <div className={"row margin-top-20"}>
                            <div className={"text-right"}>
                                <Link to={"/trips/new-internal-trip"}>
                                    <button className={"btn btn-shell z-depth-0 no-margin"}>Nuevo Viaje</button>
                                </Link>
                            </div>
                        </div>
                        :
                        <div className={'margin-top-20'} />
                    }
                    <FiltersDefaultInternal
                        inputAction={this._handleInput}
                        dateAction={this._handleDate}
                        selectAction={this._handleSelectChange}
                        state={filterState}
                    />
                    {this.state.finishedFirstFetch &&
                    <div className={'main-table fixed-height-table '}>
                        <BootstrapTable
                            remote
                            keyField='id'
                            classes={'striped highlight bordered custom-black-table'} bordered={false}
                            data={data} columns={columns}
                            noDataIndication={() => {
                                return <EmptyRow text={"No hay información disponible"}/>
                            }}
                            rowEvents={this.rowEvents}
                            pagination={pagination}
                            loading={this.state.xhr}
                            overlay={overlayFactory({
                                spinner: true,
                                background: 'rgba(192,192,192,0.85)',
                                text: 'Cargando viajes...'
                            })}
                            onTableChange={this._onTableChange}
                        />
                    </div>
                    }
                </div>
                <div className={'download-report-button'}>
                    <ExportReport filters={this._generateParams()} total_trips={this.state.total_trips} />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch)
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomeInternal));



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Home/Internal/index.js